import AppService from "./app.service";

const CoachingSummaryService = () => {
  return Object.freeze({
    getSummaries: async (accountIds, simIds) => {
      const response = await AppService.submit(
        { accountIds, simIds },
        "coaching/summaries"
      );
      return response.data;
    },
  });
};

export default CoachingSummaryService;
